module.exports = __webpack_public_path__ + "img/chuneng3.405ab9db.jpg";